<template>
  <div :class="classes">
       <pt-page-title :title="(isEdit?'':'新建')+(isIntegral?'积分商品':'')+'政策规则'+(isEdit?'修改':'')"></pt-page-title>
      <pt-sub-title title="政策规则信息"></pt-sub-title>
      <table :class="$style['policy-form-table']">
        <pt-form-list-item label="政策名称" :required="true">
            <wt-input :class="$style['policy-name']" data-vv-as="政策名称" name="name"  v-validate="'required'" v-model="formValue.name"></wt-input>
        </pt-form-list-item>
        <pt-form-list-item label="政策类型" :required="true">
            <wt-selector :class="$style['policy-name']" :options="policyTypes" v-model="type" data-vv-as="政策类型" name="name"  v-validate="'required'"></wt-selector>
        </pt-form-list-item>
         <pt-form-list-item label="政策内容" :required="true">
             <wt-input v-if="isShowInput"  v-model="formValue.content" data-vv-as="政策内容" name="name"  v-validate="'required'"></wt-input>
             <wt-ueditor :class="$style['policy-form-ueditor']" v-else resource="" ref="ueditor" v-model="formValue.content" :content="content" data-vv-as="政策内容" name="name"  v-validate="'required'"></wt-ueditor>
         </pt-form-list-item>
      </table>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { policyTabs } from '../policy-manage.js'
// 组件class前缀
const prefixCls = 'pt-policy-form'
export default {
  name: 'pt-policy-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 填写内容部分是否显示输入框
    isShowInput () {
      return this.type === 'carriage'
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    policyType: {
      type: String,
      default: ''
    },
    policyDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isIntegral: Boolean
  },
  data () {
    return {
      formValue: {},
      policyTypes: policyTabs,
      type: this.policyType && this.policyType !== 'false' ? this.policyType : '',
      content: ''
    }
  },
  watch: {
    policyDetail: {
      handler: function (val) {
        val.content = this.type !== 'afterSales' ? val.content : val.detail
        this.formValue = JSON.parse(JSON.stringify(val))
        this.content = val.content
      }
    },
    type (val) {
      this.$emit('typeChange', val)
    }
  },
  methods: {
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.policy-form-table{
    padding: 20px;
}
.policy-form-ueditor{
    td{
        padding-bottom: inherit
    }
}
.policy-name{
    width: 240px;
}
</style>
